import styled from 'styled-components';

export const StyleLeaderboardContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    margin-bottom: 100px;
    padding: 0 10%;

    @media (max-width: 1300px) {
        padding: 0 5%;
    }
`

export const StyleLeaderboardContent = styled.div`
    display: flex;
    flex-direction: row;
    gap: 2rem;

    @media (max-width: 1150px) {
        flex-direction: column;
    }
`

export const StyleLeaderboardTable = styled.table`
    border: 1px solid #FFF; 
    border-radius: 1.5rem;
    border-spacing: 0;
    flex: 1;
    height: fit-content;
    & tr:last-child td {
        border: none;
    }
`

export const StyleLeaderboardTableThead = styled.thead`
    height: 50px;
    border-top: 1px solid #FFF;
    border-bottom: 1px solid #FFF;
`

export const StyleLeaderboardTableTbody = styled.tbody`
    height: 50px;
    border-top: 1px solid #FFF;
    border-bottom: 1px solid #FFF;
`

export const StyleLeaderboardTableTr = styled.tr`
    height: 50px;
    border-top: 1px solid #FFF;
    border-bottom: 1px solid #FFF;
`

export const StyleLeaderboardTableTh = styled.th`
    color: white;
    font-weight: 400;
    border-bottom: 1px solid white;
    font-size: 16px;

    @media (max-width: 768px) {
        font-size: 14px;
    }

    @media (max-width: 560px) {
        font-size: 12px;
    }
`

export const StyleLeaderboardTableTd = styled.td`
    border: none;
    color: white;
    font-weight: 400;
    text-align: center;
    font-family: Prompt;
    font-size: 16px;
    border-bottom: 1px solid white;

    @media (max-width: 768px) {
        font-size: 14px;
    }

    @media (max-width: 560px) {
        font-size: 12px;
    }
`